<h2 mat-dialog-title>{{ headerText() }}</h2>
<mat-dialog-content>
  <span class="name">{{ data.name }}</span> {{ data.afterNameText }}
</mat-dialog-content>
<mat-dialog-actions>
  <button
    mat-raised-button
    (click)="abort()"
    cdkFocusInitial
  >{{ "no" | transloco }}</button>
  <button
    mat-raised-button
    (click)="confirm()"
  >{{ "yes" | transloco }}</button>
</mat-dialog-actions>